<template>
  <Modal
    lg
    hide-footer
    v-model="showCreateNewProject"
    :title="$t('project.add')"
    v-if="showCreateNewProject"
  >
    <ProjectForm modal @refresh="refresh"></ProjectForm>
  </Modal>
  <SelectBox
    v-else
    optionField="projectNo"
    @open="getProjects"
    @search="getProjects"
    @option:selected="$emit('option:selected', $event)"
    :options="items"
    :validActivated="validActivated"
    :label="label"
    :disabled="disabled"
    :searchable="searchable"
    :noLabel="noLabel"
    :value="value"
    :clearable="clearable"
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ item.project.model }}
    </template>
    <template #label-button>
      <Button
        @click="showCreateNewProject = true"
        size="xs"
        class="u-margin-left-xsmall"
        variant="light-primary"
      >
        + {{ $t("project.add") }}
      </Button>
    </template>
    <template #not-auth v-if="$status.project === 'NOT_AUTHORIZED'">
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
import Button from "../Base/Button.vue";
import Modal from "../Base/Modal.vue";
import ProjectForm from "../Projects/ProjectForm.vue";
export default {
  components: {
    SelectBox,
    Button,
    Modal,
    ProjectForm,
  },
  data() {
    return {
      items: [],
      showCreateNewProject: false,
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => ({}),
      type: Object,
    },
    searchable: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    refresh(data) {
      this.items.unshift(data);
      this.$emit("input", data);
      this.showCreateNewProject = false;
    },
    /*************  ✨ Codeium Command ⭐  *************/
    /**
     * Makes a request to get all batteries that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    /******  0ee3ea39-a105-45dc-a4e8-b028140daac4  *******/ async getProjects(
      search,
      loading
    ) {
      loading(true);
      const response = await Requests.ProjectMainProject.GetAll({
        query: { search: search, ...this.query },
      });
      this.$status.project = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
      } else {
        this.items = [];
      }
      loading(false);
    },
  },
};
</script>

<style></style>
